const TargetIcon = ({ color = '#374151' }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="7" stroke={color} strokeWidth="1.4" />
    <circle cx="9" cy="9" r="3" stroke={color} strokeWidth="1.4" />
    <circle cx="9" cy="9" r="0.8" fill={color} />
  </svg>
)

export default TargetIcon
